var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleMeeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_496_17)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_496_17",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 2H2V22H22V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_496_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 16.8334V4.75008C22 3.60008 21.0667 2.66675 19.9167 2.66675H4.08333C2.93333 2.66675 2 3.60008 2 4.75008V16.8334H11.5833V19.3334H7.83333V20.1667H16.1667V19.3334H12.4167V16.8334H22ZM3.84167 16.0001L10.75 9.09175L14.075 12.4167L21.1667 5.71675V16.0001H3.84167ZM4.08333 3.50008H19.9167C20.55 3.50008 21.075 3.97508 21.1583 4.58341L14.0917 11.2501L10.75 7.90841L2.83333 15.8251V4.75008C2.83333 4.05841 3.39167 3.50008 4.08333 3.50008ZM5.33333 6.83341C5.33333 6.37508 5.70833 6.00008 6.16667 6.00008C6.625 6.00008 7 6.37508 7 6.83341C7 7.29175 6.625 7.66675 6.16667 7.66675C5.70833 7.66675 5.33333 7.29175 5.33333 6.83341Z",
    fill: "#178477",
    stroke: "#178477",
    strokeWidth: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_496_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleMeeting);
export default __webpack_public_path__ + "static/media/schedule-meeting.4827abd572a89effd79c57524f67e254.svg";
export { ForwardRef as ReactComponent };